import React from 'react';
import { FiArrowUpRight } from 'react-icons/fi';

function BookingChatComposer({
  language,
  pendingPrompt,
  value,
  onChange,
  onSubmit,
  onQuickReply,
  onSkip
}) {
  const isTextPrompt = pendingPrompt?.input === 'text';

  return (
    <div className="booking-chat-composer">
      {pendingPrompt?.quickReplies?.length ? (
        <div className="booking-chat-composer__quick-replies">
          {pendingPrompt.quickReplies.map((reply) => (
            <button type="button" key={reply} className="booking-chat-composer__quick-reply" onClick={() => onQuickReply(reply)}>
              {reply}
            </button>
          ))}
        </div>
      ) : null}

      <form className="booking-chat-composer__form" onSubmit={onSubmit}>
        <textarea
          rows={2}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={pendingPrompt?.placeholder || (language === 'fr' ? 'Écrivez votre message...' : 'Type your message...')}
          disabled={!isTextPrompt}
        />
        <button type="submit" disabled={!isTextPrompt || !String(value || '').trim()}>
          <FiArrowUpRight />
        </button>
      </form>

      {pendingPrompt?.allowSkip ? (
        <button type="button" className="booking-chat-composer__skip" onClick={onSkip}>
          {language === 'fr' ? 'Passer' : 'Skip'}
        </button>
      ) : null}
    </div>
  );
}

export default BookingChatComposer;
